import { render } from "./SimpleDialog.vue?vue&type=template&id=447bdb20&scoped=true"
import script from "./SimpleDialog.vue?vue&type=script&lang=js"
export * from "./SimpleDialog.vue?vue&type=script&lang=js"

import "./SimpleDialog.vue?vue&type=style&index=0&id=447bdb20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-447bdb20"]])

export default __exports__